(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Flex-Testimonial"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to('.grid-col_two', {
      y: 120,
      ease: 'none',
      scrollTrigger: {
        trigger: '.grid-col_main_flex',
        start: 'top 50%',
        end: 'bottom top',
        scrub: true,
      },
    });

    // gsap.to('.grid-col_three', {
    //   y: -300,
    //   ease: 'none',
    //   scrollTrigger: {
    //     trigger: '.grid-col_main_flex',
    //     start: 'top bottom',
    //     end: 'bottom top',
    //     scrub: true,
    //   },
    // });

    gsap.to('.grid-col_four', {
      y: 120,
      ease: 'none',
      scrollTrigger: {
        trigger: '.grid-col_main_flex',
        start: 'top 50%',
        end: 'bottom top',
        scrub: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner-custom"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  initPageLoadEffects();
  setupScrollEffects();
  triggerBottleAnimation();
});

function initPageLoadEffects() {
  const bannerContent = document.querySelector(".banner_content");
  const bodyElement = document.body;

  if (bodyElement) {
    bodyElement.classList.add("page-loaded");
  }

  setTimeout(() => {
    bannerContent?.classList.add("active");
  }, 600);
}

function setupScrollEffects() {
  const mainImg_Arr = document.querySelectorAll('.bottle_img');
  const images = {
    image1: document.querySelector(".bottle_image1.bottle_img"),
    image2: document.querySelector(".bottle_image2.bottle_img"),
    image3: document.querySelector(".bottle_image3.bottle_img"),
    image4: document.querySelector(".bottle_image4.bottle_img"),
  };

  if (!images.image1 || !images.image2 || !images.image3 || !images.image4) return;

  const maxYShift = 80;
  const maxXShift = 60;
  let scrollEndTimer;

  function updateTransforms() {
    const scrollY = window.scrollY;
    const shiftY = Math.min(scrollY / 4, maxYShift);
    const shiftX = Math.min(scrollY / 8, maxXShift);

    images.image1.style.transform = `translate3d(0, ${shiftY}px, 0)`;
    images.image2.style.transform = `translate3d(0, ${shiftY}px, 0)`;
    images.image3.style.transform = `translate3d(${shiftX}px, ${shiftY}px, 0)`;
    images.image4.style.transform = `translate3d(-${shiftX}px, ${shiftY}px, 0)`;

    mainImg_Arr.forEach((img) => {
      img.style.willChange = 'transform';
    });

    clearTimeout(scrollEndTimer);
    scrollEndTimer = setTimeout(() => {
      mainImg_Arr.forEach((img) => {
        img.style.transition = 'transform 0.3s ease-out';
      });
    }, 100);
  }

  function onScroll() {
    requestAnimationFrame(updateTransforms);
  }

  window.addEventListener("scroll", onScroll);
}

function triggerBottleAnimation() {
  const bottles = document.querySelectorAll(".bottle_img");
  const bodyElement = document.body;
  const isSmallScreen = window.innerWidth < 550;

  bottles.forEach((el, i) => {
    if (isSmallScreen) {
      el.style.transform = 'none';
      el.classList.add("loaded");
      return;
    }

    const delay = i >= 2 ? i * 10 : (i * 50) + 500;
    setTimeout(() => {
      el.classList.add("loaded");
    }, delay);
  });

  setTimeout(() => {
    bodyElement?.classList.add("rotation-loaded");
  }, 600);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
 document.addEventListener('DOMContentLoaded', function () {
  const desktopVideo = document.querySelector('.video-desktop');
  const mobileVideo = document.querySelector('.video-mobile');
  const section = document.querySelector('.ITG_video_section');

  const handleIntersection = (videoElement) => {
    if (!videoElement) return;

    videoElement.muted = true;

    const playPromise = videoElement.play();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            videoElement.style.opacity = '1';
          } else {
            videoElement.style.opacity = '0';
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  };

  // Check screen width and apply logic accordingly
  const isMobile = window.innerWidth < 750;
  handleIntersection(isMobile ? mobileVideo : desktopVideo);

  // Optional: Set poster alt
  const posterImg = document.querySelector('.cstm_video img');
  if (posterImg) {
    posterImg.alt = 'Video preview image';
  }
});


  } catch(e) { console.error(e); }
})();
})();
